import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'
import _ from 'lodash'

const state = {
  zone: {
    color: '#000000'
  },
  available_devices: [],
  available_zones: [],
  zones: [],
  zone_types: [],
  zones_for_drop_down: []
}

const getters = {
  singleZone: state => state.zone,
  availableDevices: state => state.available_devices,
  availableZones: state => state.available_zones,
  allZones: state => state.zones,
  allZoneTypes: state => state.zone_types,
  allZonesForDropdown: state => state.zones_for_drop_down
}

const actions = {
  getZones ({ commit, rootGetters }) {
    api.instance.get('zones')
      .then(function (response) {
        const zones = response.data.zones
        let data = {}
        data.zones = zones
        data.scopedSiteId = rootGetters.scopedSiteId
        commit(types.RECEIVE_ZONES, data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getZone ({ commit }, zoneId) {
    api.instance.get('zones/' + zoneId)
      .then(function (response) {
        const zone = response.data.zone

        if (zone.extension === '0') {
          zone.extension = '6'
        }

        commit(types.RECEIVE_ZONE, zone)
      })
  },
  getZoneTypes ({ commit }) {
    api.instance.get('zone_types')
      .then(function (response) {
        const zoneTypes = response.data.zone_types
        commit(types.RECEIVE_ZONE_TYPES, zoneTypes)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getAvailableDevices ({ commit }, zoneId) {
    api.instance.get('available_devices/' + zoneId)
      .then(function (response) {
        const devices = response.data.devices
        commit(types.RECEIVE_AVAILABLE_DEVICES, devices)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getAvailableZones ({ commit }, zoneId) {
    api.instance.get('available_zones/' + zoneId)
      .then(function (response) {
        const zones = response.data.zones
        commit(types.RECEIVE_AVAILABLE_ZONES, zones)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditZone ({ commit, rootGetters }, data) {
    let zone = data.zone

    zone.site_id = rootGetters.scopedSiteId

    if (zone.color.hex !== undefined) {
      zone.color = zone.color.hex
    }

    if (zone.extension === '') {
      zone.extension = '6'
    }

    if (zone.extension === '6') {
      zone.extension = '0'
    }

    if (zone.zone_id === 0) {
      api.instance.post('zones', zone)
        .then(function (response) {
          if (response.data.success === 'true') {
            zone.zone_id = response.data.zone[0].zone_id
            zone.extension = response.data.zone[0].extension
            zone.site = response.data.zone[0].site
            commit(types.ADD_ZONE, zone)

            if (data.next !== null) {
              router.push({ name: data.next })
            }
          } else {
            alert(response.data.message)
          }
        })
    } else {
      api.instance.put('zones/' + zone.zone_id, zone)
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.EDIT_ZONE, zone)
            if (data.next !== null) {
              router.push({ name: data.next })
            }
          } else {
            alert(response.data.message)
          }
        })
    }
  },
  assignDevices ({ commit }, zone) {
    api.instance.post('zone_devices/' + zone.zone_id, zone.zone_devices)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.EDIT_ZONE, zone)
          router.push({ name: 'ZoneManager' })
        } else {
          alert(response.data.message)
        }
      })
  },
  assignZones ({ commit }, zone) {
    api.instance.post('zone_zones/' + zone.zone_id, zone.zone_zones)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.EDIT_ZONE, zone)
          router.push({ name: 'ZoneManager' })
        } else {
          alert(response.data.message)
        }
      })
  },
  deleteZone ({ commit }, zone) {
    api.instance.delete('zones/' + zone.zone_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_ZONE, zone)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_ZONES] (state, data) {
    let zones = data.zones
    state.zones = _.orderBy(zones, ['site_id', 'name'])

    state.zones_for_drop_down = state.zones.filter(zone => zone.site_id === data.scopedSiteId && zone.zone_type_id !== 4).map(zone => {
      return {
        'value': zone.zone_id,
        'label': zone.name
      }
    })
  },
  [types.RECEIVE_ZONE] (state, zone) {
    state.zone = zone
  },
  [types.RECEIVE_ZONE_TYPES] (state, zoneTypes) {
    state.zone_types = zoneTypes
  },
  [types.RECEIVE_AVAILABLE_DEVICES] (state, devices) {
    state.available_devices = _.orderBy(devices, 'name')
  },
  [types.RECEIVE_AVAILABLE_ZONES] (state, zones) {
    state.available_zones = _.orderBy(zones, 'name')
  },
  [types.ADD_ZONE] (state, zone) {
    state.zones.push(zone)

    state.zones = _.orderBy(state.zones, 'name')
  },
  [types.EDIT_ZONE] (state, zone) {
    let zoneToEdit = state.zones.find(
      function (ele) {
        if (ele.zone_id === zone.zone_id) {
          return true
        }
      }
    )
    let index = state.zones.indexOf(zoneToEdit)
    state.zones[index] = zone

    state.zones = _.orderBy(state.zones, 'name')
  },
  [types.DELETE_ZONE] (state, zone) {
    let zoneToDelete = state.zones.find(
      function (ele) {
        if (ele.zone_id === zone.zone_id) {
          return true
        }
      }
    )
    let index = state.zones.indexOf(zoneToDelete)
    state.zones.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
